import React__default from 'react';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import { FreeBetsStatus } from '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../loadingStore-ee04ce42.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-14fce7b4.js';
import '../../../core/polyfill.js';
import '../../../../tslib.es6-14c74580.js';
import 'mobx';
import '@microsoft/signalr';
import '../../../core/classes/httpResponse/index.js';
import '../../../core/helpers/environmentBuilder.js';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/helpers/updateHalfBets.js';
import '../../../core/enums/bogGameNames.js';
import 'howler';
import '../../../../_commonjsHelpers-1a7a244d.js';

var FreeBetsList = function (_a) {
    var t = _a.t, freeBetsList = _a.freeBetsList, selectFreeBet = _a.selectFreeBet, handleInfoData = _a.handleInfoData, selectedFreeBetId = _a.selectedFreeBetId, isBogLine = _a.isBogLine;
    return (React__default.createElement("div", { className: 'free-bets-wr-bottom' },
        React__default.createElement("div", { className: 'free-bets-wr-bottom-head' },
            React__default.createElement("div", { className: 'free-bets-wr-bottom-head-row' }, t(TranslationKeys.Count)),
            React__default.createElement("div", { className: 'free-bets-wr-bottom-head-row' }, t(TranslationKeys.Bet1)),
            isBogLine && (React__default.createElement("div", { className: 'free-bets-wr-bottom-head-row sub' },
                t(TranslationKeys.OddFreeBet),
                React__default.createElement("span", { className: 'free-bets-wr-bottom-head-row-txt' }, t(TranslationKeys.Min)))),
            React__default.createElement("div", { className: 'free-bets-wr-bottom-head-date' }, t(TranslationKeys.EndDate))),
        React__default.createElement("div", { className: 'free-bets-wr-bottom-content' },
            React__default.createElement("div", { className: 'scrollable-container' }, freeBetsList.map(function (freeBet) { return (React__default.createElement("div", { className: "free-bets-wr-bottom-content-wrap ".concat(selectedFreeBetId === freeBet.id ? 'active' : ''), key: freeBet.id },
                React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' }, freeBet.count),
                React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' }, freeBet.amount),
                isBogLine && React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' },
                    "x",
                    freeBet.minOdd),
                React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-date' },
                    freeBet.expireDateFreeBet,
                    React__default.createElement("span", { className: 'free-bets-wr-bottom-content-wr-txt' }, freeBet.expiredTime)),
                React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-info' },
                    React__default.createElement("div", { className: 'free-bets-wr-bottom-content-wr-info-icon', onClick: function (evt) { return handleInfoData(evt, freeBet); } },
                        React__default.createElement("i", { className: 'ui-lib-question' })),
                    React__default.createElement("div", { className: "free-bets-wr-bottom-content-wr-info-switch ".concat(freeBet.remainingCount === 0 || freeBet.status === FreeBetsStatus.Expired ? 'disabled' : '') },
                        React__default.createElement("label", { className: 'switch' },
                            React__default.createElement("input", { type: 'checkbox', checked: freeBet.id === selectedFreeBetId, onChange: function () { return selectFreeBet(freeBet); } }),
                            React__default.createElement("span", { className: 'slider round' })))))); })))));
};

export { FreeBetsList };
